module.exports = __webpack_public_path__ + "img/s1.f7b07112.png";